import clsx from "clsx";
import React, { ReactElement } from "react";
import { useAppSelector } from "../../../lib/redux/hook.ts";

interface Props {
    toRead: boolean
    icon: ReactElement
    label: string
    subLabel: string
    secondIcon: ReactElement
    menu?: ReactElement
    thirdLabel?: string
    onClick?: () => void
}

export function GroupedRow(props: Props) {
    const { toRead } = props;
    const { icon } = props;
    const { subLabel } = props;
    const { label } = props;
    const { secondIcon } = props;
    const { menu } = props;
    const { thirdLabel } = props

    const layoutState = useAppSelector(state => state.layout)

    return (
        <div
            style={{ backgroundColor: toRead ? layoutState.theme[50] : layoutState.theme[100] }}
            onClick={() => { props.onClick && props.onClick() }}
            className={
                clsx("rounded-3xl cursor-pointer p-4 gap-1 w-full flex flex-row items-center justify-between")}
        >
            <div className="flex flex-row gap-2 items-center">
                {icon}
                <div className={"flex flex-col gap-2"}>
                    <span className="text-label-sm text-brandSecondary-600 font-semibold">{label}</span>
                    <div className="flex flex-row gap-1 items-center">
                        <span className="text-label-xs text-neutral-500 font-medium">{subLabel}</span>
                        <span className="text-label-xs font-medium" style={{ color: layoutState.theme[500] }}>{thirdLabel}</span>
                    </div>
                </div>
            </div>
            <div className="flex flex-row items-center gap-3 cursor-pointer">
                {secondIcon}
                {menu}
            </div>
        </div>
    )
}